import { render, staticRenderFns } from "./addTaxe.vue?vue&type=template&id=5344403a"
import script from "./addTaxe.vue?vue&type=script&lang=js"
export * from "./addTaxe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports